import { render, staticRenderFns } from "./listOfGames.vue?vue&type=template&id=39e97436&scoped=true&"
import script from "./listOfGames.vue?vue&type=script&lang=js&"
export * from "./listOfGames.vue?vue&type=script&lang=js&"
import style0 from "./listOfGames.vue?vue&type=style&index=0&id=39e97436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e97436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VFlex,VLayout,VProgressCircular,VSwitch})
